import { render, staticRenderFns } from "./card-house.vue?vue&type=template&id=f5baf7a6&scoped=true&"
import script from "./card-house.vue?vue&type=script&lang=js&"
export * from "./card-house.vue?vue&type=script&lang=js&"
import style0 from "./card-house.vue?vue&type=style&index=0&id=f5baf7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5baf7a6",
  null
  
)

export default component.exports